import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined'
import OpenInNew from '@material-ui/icons/OpenInNew'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {Trans} from 'react-i18next'
import messages from '../../../../assets/messages'
import {config} from '../../../../config'
import {PammOfferType} from '../../../../graphql/types'
import {ActionButton, Actions} from './OfferCardActions.styled'

type OfferCardActionsProps = {
  offer: PammOfferType
}

/**
 * Copy Link and Invest actions for an offer card. Both target the offer's join link
 * (`?pammManager=&pammOffer=`): Copy Link copies it, Invest opens it in a new tab.
 *
 * @param offer - The PAMM offer whose join link the actions operate on.
 */
export const OfferCardActions = ({offer}: OfferCardActionsProps) => {
  const joinLink = `${config.frontendUrl}?pammManager=${offer.skygroundAccountId}&pammOffer=${offer.id}`

  return (
    <Actions>
      <CopyToClipboard text={joinLink}>
        <ActionButton variant="outlined" size="small" startIcon={<FileCopyOutlined />}>
          <Trans {...messages.copyLink} />
        </ActionButton>
      </CopyToClipboard>
      <ActionButton
        variant="contained"
        color="primary"
        size="small"
        endIcon={<OpenInNew />}
        onClick={() => window.open(joinLink, '_blank', 'noopener,noreferrer')}
      >
        <Trans {...messages.invest} />
      </ActionButton>
    </Actions>
  )
}
